import normatize from '~/utils/string/normatize';

function createTrack(options) {
	const opts = Object(options);
	return {
		event: opts.event || 'interaction',
		eventActor: 'user',
		segment: 'landing-page',
		product: 'nova-strada-laranja',
		interactionType: opts.type || '-',
		component: {
			part: opts.part || 'conteudo',
			props: {
				section: opts.section || '-',
				subsection: opts.subsection || '-',
				cluster: opts.theme || '-',
				'element-text': opts.elementText || '-',
			},
		},
	};
}

function track(type, section, subsection, part, elementText, theme, cluster, device) {
	const isViewpage  = /^(?:view|vpv)$/i.test(type);
	const event = isViewpage ? type : 'interaction';
	type = isViewpage ? 'abertura' : type;
	if (!/^(?:clique|abertura|fechamento|remocao|selecao|preencheu)$/.test(type)) {
		// console.error('track.interactionType is wrong at:', { event, type, section, subsection, part, elementText, theme, cluster, device });
	}
	if (!/^(?:header|footer|conteudo)$/.test(part)) {
		// console.error('track.part is wrong at:', { event, type, section, subsection, part, elementText, theme, cluster, device });
	}
	return createTrack({ event, type, section, subsection, part, elementText, theme, cluster, device });
}

export const data = {
	WhatsappPage_ClicouCompreOSeu: (theme, cluster, device) => {
		return track('clique', 'whatsapp', 'cta', 'conteudo', 'fale-com-analista', theme, cluster, device);
	},
	// General ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	App_Iniciou: (theme, cluster, device) => {
		return null;
	},
	App_Pageview: (section, theme, cluster, device) => {
		if (/^(interior|design|performance|tecnologia|seguranca|for[cç]a[-\s]e[-\s]pot[eê]ncia|s-design|servi[çc]os?)$/i.test(section)) return null;
		if (/^(fotos)$/.test(section) && device === 'm') return null;
		if (/^(about)$/.test(section)) section = 'sobre';
		if (/^(live)$/.test(section)) section = 'realidade-aumentada';
		return track('vpv', section, '', null, null, theme, cluster, device);
	},

	// Menu ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	Menu_ClicouAbrir: (theme, cluster, device) => {//ok
		return track('abertura', 'menu-lateral', 'menu-lateral', 'conteudo', 'menu', theme, cluster, device);
	},
	Menu_ClicouFechar: (theme, cluster, device) => {//ok
		return track('fechamento', 'menu-lateral', 'menu-lateral', 'conteudo', 'menu', theme, cluster, device);
	},
	Menu_ClicouLogoCarro: (theme, cluster, device) => {// N/A
		return track('clique', 'menu-lateral', 'menu-lateral', 'conteudo', 'logo-strada', theme, cluster, device);
	},
	Menu_ClicouLogoFiat: (theme, cluster, device) => {// N/A
		return track('clique', 'menu-lateral', 'menu-lateral', 'conteudo', 'logo-fiat', theme, cluster, device);
	},
	Menu_ClicouPin: (theme, cluster, device) => {//ok
		return track('clique', 'menu-lateral', 'menu-lateral', 'conteudo', 'concessionarias', theme, cluster, device);
	},
	Menu_ClicouItem: (section, theme, cluster, device) => {//ok
		return track('clique', 'menu-lateral', 'menu-lateral', 'conteudo', normatize(section), theme, cluster, device);
	},
	Menu_ClicouMonteOSeu: (title, theme, cluster, device) => {//ok
		return track('clique', 'menu-lateral', 'cta', 'conteudo', 'monte-o-seu', theme, cluster, device);
	},
	Menu_ClicouSimularFinanciamento: (title, theme, cluster, device) => {//ok
		return track('clique', 'menu-lateral', 'cta', 'conteudo', 'simule-um-financiamento', theme, cluster, device);
	},
	Menu_ClicouFaleComAFiat: (title, theme, cluster, device) => {//ok
		return track('clique', 'menu-lateral', 'cta', 'conteudo', 'fale-com-a-fiat', theme, cluster, device);
	},
	Menu_ClicouAgendeSeuTesteDrive: (title, theme, cluster, device) => {//ok
		return track('clique', 'menu-lateral', 'cta', 'conteudo', 'compre-o-seu', theme, cluster, device);
	},
	Menu_ClicouConcessionarias: (title, theme, cluster, device) => {//ok
		return track('clique', 'menu-lateral', 'cta', 'conteudo', 'concessionarias', theme, cluster, device);
	},
	Menu_ClicouOfertasFiat: (title, theme, cluster, device) => {//ok
		return track('clique', 'menu-lateral', 'cta', 'conteudo', 'ofertas-fiat', theme, cluster, device);
	},

	// Menu Fixed ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	MenuFixed_abrir: (theme, cluster, device) => {// N/A
		return track('abertura', 'menu-flutuante', 'menu-flutuante', 'conteudo', 'menu', theme, cluster, device);
	},
	MenuFixed_fechar: (theme, cluster, device) => {// N/A
		return track('fechamento', 'menu-flutuante', 'menu-flutuante', 'conteudo', 'menu', theme, cluster, device);
	},
	MenuFixed_ClicouItem: (title, theme, cluster, device) => {// N/A
		return null;
	},
	MenuFixed_ClicouMonteOSeuArgo: (title, theme, cluster, device) => {// N/A
		return track('clique', 'menu-flutuante', 'cta', 'conteudo', 'monte-o-seu', theme, cluster, device);
	},
	MenuFixed_ClicouFaleComAFiat: (title, theme, cluster, device) => {// N/A
		return track('clique', 'menu-flutuante', 'cta', 'conteudo', 'fale-com-a-fiat', theme, cluster, device);
	},
	MenuFixed_ClicouSimularFinanciamento: (title, theme, cluster, device) => {// N/A
		return track('clique', 'menu-flutuante', 'cta', 'conteudo', 'simule-um-financiamento', theme, cluster, device);
	},
	MenuFixed_ClicouAgendeSeuTesteDrive: (title, theme, cluster, device) => {// N/A
		return track('clique', 'menu-flutuante', 'cta', 'conteudo', 'compre-o-seu', theme, cluster, device);
	},
	MenuFixed_ClicouConcessionarias: (title, theme, cluster, device) => {// N/A
		return track('clique', 'menu-flutuante', 'cta', 'conteudo', 'concessionarias', theme, cluster, device);
	},
	MenuFixed_ClicouOfertasFiat: (title, theme, cluster, device) => {// N/A
		return track('clique', 'menu-flutuante', 'cta', 'conteudo', 'ofertas-fiat', theme, cluster, device);
	},

	// Formulario ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	FormSchedule_Abriu: (theme, cluster, device) => {//ok
		// return track('view', 'compre-o-seu', 'compre-o-seu', 'formulario', 'abrir', theme, cluster, device);
	},
	FormSchedule_PreencheuNome: (theme, cluster, device) => {// N/A
		return track('preencheu', 'compre-o-seu', 'compre-o-seu', 'formulario', 'nome', theme, cluster, device);
	},
	FormSchedule_PreencheuEmail: (theme, cluster, device) => {// N/A
		return track('preencheu', 'compre-o-seu', 'compre-o-seu', 'formulario', 'email', theme, cluster, device);
	},
	FormSchedule_PreencheuTelefone: (theme, cluster, device) => {// N/A
		return track('preencheu', 'compre-o-seu', 'compre-o-seu', 'formulario', 'telefone', theme, cluster, device);
	},
	FormSchedule_PreencheuPerfil: (value, theme, cluster, device) => {//ok
		return track('preencheu', 'compre-o-seu', 'compre-o-seu', 'formulario', 'perfil', theme, cluster, device);
	},
	FormSchedule_PreencheuCPF_CNPJ: (value, theme, cluster, device) => {// N/A+
		return track('preencheu', 'compre-o-seu', 'compre-o-seu', 'formulario', 'cpf', theme, cluster, device);
	},
	FormSchedule_PreencheuVersao: (value, theme, cluster, device) => {//ok
		return track('preencheu', 'compre-o-seu', 'compre-o-seu', 'formulario', 'versao', theme, cluster, device);
	},
	FormSchedule_PreencheuMensagem: (value, theme, cluster, device) => {// N/A
		return track('preencheu', 'compre-o-seu', 'compre-o-seu', 'formulario', 'mensagem', theme, cluster, device);
	},
	FormSchedule_PreencheuCep: (value, theme, cluster, device) => {// N/A
		return track('preencheu', 'compre-o-seu', 'compre-o-seu', 'formulario', 'cep', theme, cluster, device);
	},
	FormSchedule_AddTelefone: (theme, cluster, device) => {// N/A
		return track('clique', 'compre-o-seu', 'compre-o-seu', 'formulario', 'add-telefone', theme, cluster, device);
	},
	FormSchedule_ClicouFechar: (theme, cluster, device) => {//ok
		return track('clique', 'compre-o-seu', 'compre-o-seu', 'formulario', 'fechar', theme, cluster, device);
	},
	FormSchedule_ClicouEnviar: (theme, cluster, device) => {//ok
		return track('clique', 'compre-o-seu', 'compre-o-seu', 'formulario', 'lead-enviar', theme, cluster, device);
	},
	FormSchedule_Enviou: (status, theme, cluster, device) => {//ok
		return track('clique', 'compre-o-seu', 'compre-o-seu', 'formulario', 'lead-sucesso', theme, cluster, device);
	},
	FormSchedule_FecharEnviado: (status, theme, cluster, device) => {// N/A
		// return track('clique', 'compre-o-seu', 'compre-o-seu', 'formulario', 'fechar-x-enviado', theme, cluster, device);
	},
	FormSchedule_CEPCidade: (status, theme, cluster, device) => {// N/A
		return track('preencheu', 'compre-o-seu', 'compre-o-seu', 'formulario', 'cep-cidade', theme, cluster, device);
	},
	FormSchedule_FecharSucesso: (status, theme, cluster, device) => {// N/A
		return track('fechamento', 'compre-o-seu', 'compre-o-seu', 'formulario', 'botao-fechar', theme, cluster, device);
	},
	FormSchedule_ClicouReceberComunicacaoTelefone: (value, theme, cluster, device) => {//ok
		return track('selecao', 'compre-o-seu', 'compre-o-seu', 'formulario', 'aceito-comunicacao-telefone', theme, cluster, device);
	},
	FormSchedule_ClicouNaoReceberComunicacaoTelefone: (value, theme, cluster, device) => {//ok
		return track('remocao', 'compre-o-seu', 'compre-o-seu', 'formulario', 'nao-aceito-comunicacao-telefone', theme, cluster, device);
	},
	FormSchedule_ClicouReceberComunicacaoEmail: (value, theme, cluster, device) => {//ok
		return track('selecao', 'compre-o-seu', 'compre-o-seu', 'formulario', 'aceito-comunicacao-email', theme, cluster, device);
	},
	FormSchedule_ClicouNaoReceberComunicacaoEmail: (value, theme, cluster, device) => {// N/A
		return track('remocao', 'compre-o-seu', 'compre-o-seu', 'formulario', 'nao-aceito-comunicacao-email', theme, cluster, device);
	},
	FormSchedule_SelecionouConcessionaria: (value, theme, cluster, device) => {//ok
		return track('selecao', 'compre-o-seu', 'compre-o-seu', 'formulario', 'concessionaria', theme, cluster, device);
	},

	// Modal ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	Modal_Fechou: (pathname, theme, cluster, device) => {//ok
		// return track('fechamento', 'destaque', 'home', 'conteudo', 'fechou', theme, cluster, device);
	},
	Modal_Fechou_WithTitle: (title, theme, cluster, device) => {//ok
		return track('fechamento', 'destaque', 'a-lider-das-picapes', 'conteudo', normatize(title), theme, cluster, device);
	},

	// Modal Tabs ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	ModalTabs_Abriu: (title, theme, cluster, device) => {//ok
		return track('vpv', 'destaque', 'a-lider-das-picapes', 'conteudo', normatize(title), theme, cluster, device);
	},
	ModalTabs_ClicouPoster: (posterTitle, sessionTitle, theme, cluster, device) => {//ok
		const section = normatize(sessionTitle);
		const subsection = normatize(posterTitle);
		return track('clique', 'destaque', 'a-lider-das-picapes', 'conteudo', `${section}:${subsection}`, theme, cluster, device);
	},
	ModalTabs_ClicouTab: (tabTitle, sessionTitle, index, theme, cluster, device) => {//ok
		const section = normatize(sessionTitle);
		const subsection = normatize(tabTitle);
		return track('clique', 'destaque', 'a-lider-das-picapes', 'conteudo', `${section}:${subsection}:${index}`, theme, cluster, device);
	},
	ModalTabs_MudouTab: (tabTitle, sessionTitle, index, theme, cluster, device) => {//ok
		// return track('view', tabTitle, sessionTitle, 'conteudo', null, theme, cluster, device);
	},
	ModalTabs_Scroll: (tabTitle, sessionTitle, index, theme, cluster, device) => {//ok
		const complemento = ':scroll-lateral';
		const section = normatize(sessionTitle);
		const subsection = normatize(tabTitle);
		return track('clique', 'destaque', 'a-lider-das-picapes', 'conteudo', `${section}:${subsection}:${index}${complemento}`, theme, cluster, device);
	},
	ModalTabs_videoPlay: (tabTitle, sessionTitle, theme, cluster, device) => {//ok
		const complemento = ':play';
		const section = normatize(sessionTitle);
		const subsection = normatize(tabTitle);
		return track('clique', 'destaque', 'a-lider-das-picapes', 'conteudo', `${section}:${subsection}${complemento}`, theme, cluster, device);
	},
	ModalTabs_videoPause: (tabTitle, sessionTitle, theme, cluster, device) => {//ok
		const complemento = ':pause';
		const section = normatize(sessionTitle);
		const subsection = normatize(tabTitle);
		return track('clique', 'destaque', 'a-lider-das-picapes', 'conteudo', `${section}:${subsection}${complemento}`, theme, cluster, device);
	},

	// Modal Gallery ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	ModalGallery_Abriu: (title, theme, cluster, device) => {//ok
		return track('vpv', 'destaque', 'a-lider-das-picapes', 'conteudo', normatize(title), theme, cluster, device);
	},
	ModalGallery_ThumbsScroll: (tabTitle, sessionTitle, index, theme, cluster, device) => {//ok
		const complemento = ':scroll-lateral';
		const section = normatize(sessionTitle);
		const subsection = normatize(tabTitle);
		return track('clique', 'destaque', 'a-lider-das-picapes', 'conteudo', `${section}:${subsection}${complemento}`, theme, cluster, device);
	},
	ModalGallery_ClicouPoster: (posterTitle, sessionTitle, theme, cluster, device) => {//ok
		const section = normatize(sessionTitle);
		const subsection = normatize(posterTitle);
		return track('clique', 'destaque', 'a-lider-das-picapes', 'conteudo', `${section}:${subsection}`, theme, cluster, device);
	},
	ModalGallery_ClicouThumb: (thumbTitle, sessionTitle, index, theme, cluster, device) => {//ok
		const section = normatize(sessionTitle);
		const subsection = normatize(thumbTitle);
		return track('clique', 'destaque', 'a-lider-das-picapes', 'conteudo', `${section}:${subsection}:${index}`, theme, cluster, device);
	},
	ModalGallery_MudouPoster: (thumbTitle, sessionTitle, index, theme, cluster, device) => {// N/A
		// const complemento = ':scroll-lateral';
		// const section = normatize(sessionTitle);
		// const subsection = normatize(thumbTitle);
		// return track('view', 'destaque', 'a-lider-das-picapes', 'conteudo', `${section}:${subsection}:${index}${complemento}`, theme, cluster, device);
	},
	ModalGallery_Scroll: (thumbTitle, sessionTitle, index, theme, cluster, device) => {//ok
		const complemento = ':scroll-lateral';
		const section = normatize(sessionTitle);
		const subsection = normatize(thumbTitle);
		return track('clique', 'destaque', 'a-lider-das-picapes', 'conteudo', `${section}:${subsection}:${index}${complemento}`, theme, cluster, device);
	},
	ModalGallery_videoPlay: (tabTitle, sessionTitle, theme, cluster, device) => {//ok
		const complemento = ':play';
		const section = normatize(tabTitle);
		const subsection = normatize(sessionTitle);
		return track('clique', 'destaque', 'a-lider-das-picapes', 'conteudo', `${section}:${subsection}${complemento}`, theme, cluster, device);
	},
	ModalGallery_videoPause: (tabTitle, sessionTitle, theme, cluster, device) => {//ok
		const complemento = ':pause';
		const section = normatize(tabTitle);
		const subsection = normatize(sessionTitle);
		return track('clique', 'destaque', 'a-lider-das-picapes', 'conteudo', `${section}:${subsection}${complemento}`, theme, cluster, device);
	},

	// MainPage ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	MainPage_ClicouThumbnail: (title, theme, cluster, device) => {// ???
		return track('abertura', 'destaque', 'a-lider-das-picapes', 'conteudo', normatize(title), theme, cluster, device);
	},
	MainPage_ClicouProximo: (index, theme, cluster, device) => {// N/A
		return track('clique', 'destaque', 'a-lider-das-picapes', 'conteudo', 'avancar', theme, cluster, device);
	},
	MainPage_ClicouAnterior: (index, theme, cluster, device) => {// N/A
		return track('clique', 'destaque', 'a-lider-das-picapes', 'conteudo', 'voltar', theme, cluster, device);
	},

	// LivePage ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	LivePage_ClicouAtivarVR: (theme, cluster, device) => {
		return track('clique', 'realidade-aumentada', 'realidade-aumentada', 'conteudo', 'ativar-realidade-aumentada', theme, cluster, device);
	},

	// TipPage ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	TipPage_ClicouShare: (title, theme, cluster, device) => {// N/A
		return track('clique', 'versao-sugerida', 'cta', 'conteudo', 'compartilhar-facebook', theme, cluster, device);
	},
	TipPage_ClicouCustomize: (theme, cluster, device) => {// N/A
		return track('clique', 'versao-sugerida', 'cta', 'conteudo', 'monte-o-seu', theme, cluster, device);
	},
	TipPage_ClicouAgende: (theme, cluster, device) => {// N/A
		return track('clique', 'versao-sugerida', 'cta', 'conteudo', 'compre-o-seu', theme, cluster, device);
	},
	TipPage_ClicouBullet: (title, theme, cluster, device) => {// N/A
		return track('clique', 'versao-sugerida', 'galeria', 'conteudo', normatize(title), theme, cluster, device);
	},
	TipPage_ClicouPoster: (title, theme, cluster, device) => {// N/A
		// return track('clique', 'versao-sugerida', 'galeria', 'conteudo', normatize(title), theme, cluster, device);
	},
	TipPage_ClicouThumb: (title, theme, cluster, device) => {// N/A
		// return track('clique', 'versao-sugerida', 'galeria', 'conteudo', normatize(title), theme, cluster, device);
	},
	TipPage_ClicouNext: (index, theme, cluster, device) => {// N/A
		return track('clique', 'versao-sugerida', 'galeria', 'conteudo', 'mais-imagens-avancar', theme, cluster, device);
	},
	TipPage_ClicouPrev: (index, theme, cluster, device) => {// N/A
		return track('clique', 'versao-sugerida', 'galeria', 'conteudo', 'mais-imagens-voltar', theme, cluster, device);
	},
	TipPage_ClicouDica: (title, caption, theme, cluster, device) => {// N/A
		return track('clique', 'versao-sugerida', 'galeria', 'conteudo', normatize(title), theme, cluster, device);
	},
	TipPage_MudouDica: (title, caption, theme, cluster, device) => {// N/A
		// return track('view', 'versao-sugerida', 'galeria', 'conteudo', normatize(title), theme, cluster, device);
	},

	// VersionsPage ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// 'clique', 'todas-as-versoes', 'versao', 'conteudo', '<nome-do-carro>'
	// 'clique', 'todas-as-versoes', '<nome-do-carro>', 'conteudo', 'compare-as-versoes'
	// 'interacao', 'todas-as-versoes', '<nome-do-carro>', 'conteudo', '360'
	// 'clique', 'todas-as-versoes', 'cta', 'conteudo', 'compre-o-seu'
	VersionsPage_SelecionouCabine: (type, theme, cluster, device) => {// N/A
		return track('selecao', 'todas-as-versoes', 'versao', 'conteudo', `cabine-${normatize(type)}`, theme, cluster, device); // ok 32
	},
	VersionsPage_ClicouOfertas: (version, theme, cluster, device) => {// N/A
		return track('clique', 'todas-as-versoes', normatize(version), 'conteudo', 'cta:ofertas-fiat', theme, cluster, device); // ok 32
	},
	VersionsPage_GirouCarro: (version, color, label, theme, cluster, device) => {// N/A
		return track('interacao', 'todas-as-versoes', normatize(version), 'conteudo', '360', theme, cluster, device);
	},
	VersionsPage_GirouCarroPrimeiraVez: (version, color, label, theme, cluster, device) => {// N/A
		return track('interacao', 'todas-as-versoes', normatize(version), 'conteudo', '360', theme, cluster, device);
	},
	VersionsPage_SelecionouVersaoCarro: (version, color, label, theme, cluster, device) => {// N/A
		return track('selecao', 'todas-as-versoes', 'versao', 'conteudo', normatize(version), theme, cluster, device);
	},
	VersionsPage_ClicouCompreOSeu: (version, theme, cluster, device) => {// N/A
		return track('clique', 'todas-as-versoes', 'cta', 'conteudo', 'compre-o-seu', theme, cluster, device);
	},
	VersionsPage_ClicouTrocarModoCabine: (type, theme, cluster, device) => {
		return track('selecao', 'todas-as-versoes', 'versao', 'conteudo', `cabine-${type}`, theme, cluster, device);
	},
	VersionsPage_ClicouCompareVersoes: (version, theme, cluster, device) => {// N/A
		return track('clique', 'todas-as-versoes', normatize(version), 'conteudo', 'compare-as-versoes', theme, cluster, device);
	},
	// <TODO: Comparativo de versões>
	VersionsPage_SelecionouVeiculo1: (version, theme, cluster, device) => {
		return track('selecao', 'todas-as-versoes', 'compare-as-versoes', 'conteudo', `veiculo-1-${version}`, theme, cluster, device);
	},
	VersionsPage_SelecionouVeiculo2: (version, theme, cluster, device) => {
		return track('selecao', 'todas-as-versoes', 'compare-as-versoes', 'conteudo', `veiculo-2-${version}`, theme, cluster, device);
	},
	VersionsPage_CompreOSeuV1: (version, theme, cluster, device) => {
		return track('clique', 'todas-as-versoes', 'compare-as-versoes-cta', 'conteudo', `compre-o-sua-v1-${version}`, theme, cluster, device);
	},
	VersionsPage_CompreOSeuV2: (version, theme, cluster, device) => {
		return track('clique', 'todas-as-versoes', 'compare-as-versoes-cta', 'conteudo', `compre-o-sua-v2-${version}`, theme, cluster, device);
	},
	// </TODO: Comparativo de versões>

	// Vendas Diretas ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// VdPage_ClicouContentButton:(subsection, title, theme, cluster, device) => {
	// 	return track('clique', 'venda-direta', normatize(subsection), 'conteudo', normatize(title), theme, cluster, device);
	// },
	// Clicou_VdEmpresas:(theme, cluster, device) => {
	// 	return track('clique', 'venda-direta', 'venda-direta', 'conteudo', 'empresas', theme, cluster, device);
	// },
	// Clicou_VdProdutorRural:(theme, cluster, device) => {
	// 	return track('clique', 'venda-direta', 'venda-direta', 'conteudo', 'produtor-rural', theme, cluster, device);
	// },
	// Clicou_VdEmpresasCompreOSeu:(theme, cluster, device) => {
	// 	return track('clique', 'venda-direta', 'empresas' , 'conteudo', 'cta-compre-a-sua', theme, cluster, device);
	// },
	// Clicou_VdEmpresasSaibaMais:(theme, cluster, device) => {
	// 	return track('clique', 'venda-direta', 'empresas' , 'conteudo', 'saiba-mais', theme, cluster, device);
	// },
	// Clicou_VdProdutorRuralSaibaMais:(theme, cluster, device) => {
	// 	return track('clique', 'venda-direta', 'produtor-rural', 'conteudo', 'saiba-mais', theme, cluster, device);
	// },
	// Clicou_VdProdutorRuralCompreOSeu:(theme, cluster, device) => {
	// 	return track('clique', 'venda-direta', 'produtor-rural', 'conteudo', 'cta-compre-a-sua', theme, cluster, device);
	// },

	// AboutPage ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	AboutPage_ClicouTabMobile: (title, open, theme, cluster, device) => {//ok
		const action = `${open ? 'abertura' : 'fechamento'}`;
		return track(action, 'sobre', 'sobre', 'conteudo', normatize(title), theme, cluster, device);
	},
	AboutPage_ClicouTab: (title, theme, cluster, device) => {//ok
		return track('abertura', 'sobre', 'sobre', 'conteudo', normatize(title), theme, cluster, device);
	},
	AboutPage_ClicouTab_Close: (title, theme, cluster, device) => {//ok
		// return track('clique', 'sobre', normatize(title), 'conteudo', 'fechar', theme, cluster, device);
	},
	AboutPage_ClicouPoster: (index, title, theme, cluster, device) => {//ok
		// return track('clique', 'sobre', normatize(title), 'conteudo', null, theme, cluster, device);
	},
	AboutPage_ClicouBullet: (index, title, session, theme, cluster, device) => {//ok
		// return track('clique', 'sobre', normatize(title), 'conteudo', null, theme, cluster, device);
	},
	AboutPage_MudouPoster: (title, subsectionName, theme, cluster, device) => {//ok
		const complemento = device === 'm' ? ':scroll-lateral' : '';
		const subsection = normatize(subsectionName);
		const name = normatize(title);
		return track('clique', 'sobre', subsection, 'conteudo', `${name}${complemento}`, theme, cluster, device);
	},
	AboutPage_ArrowPrevPoster: (title, theme, cluster, device) => {//ok
		return track('clique', 'sobre', 'sobre', 'conteudo', 'anterior', theme, cluster, device);
	},
	AboutPage_ArrowNextPoster: (title, theme, cluster, device) => {//ok
		return track('clique', 'sobre', 'sobre', 'conteudo', 'proxima', theme, cluster, device);
	},
	AboutPage_ContentButton: (section, contentTitle, buttonLabel, theme, cluster, device) => {// N/A
		return track('clique', 'sobre', normatize(contentTitle), 'conteudo', normatize(buttonLabel), theme, cluster, device);
	},

	// // VdPage ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// VdPage_ClicouVoltar: (title, theme, cluster, device) => {
	// 	return track('clique', 'venda-direta', 'venda-direta', 'conteudo', normatize(title), theme, cluster, device);
	// },
	// VdPage_ClicouAvancar: (title, theme, cluster, device) => {
	// 	return track('clique', 'venda-direta', 'venda-direta', 'conteudo', normatize(title), theme, cluster, device);
	// },
	// VdPage_ClicouTabMobile: (title, open, theme, cluster, device) => {//ok
	// 	const action = `${open ? 'abertura' : 'fechamento'}`;
	// 	return track(action, 'sobre', 'sobre', 'conteudo', normatize(title), theme, cluster, device);
	// },
	// VdPage_ClicouTab: (title, theme, cluster, device) => {//ok
	// 	return track('abertura', 'sobre', 'sobre', 'conteudo', normatize(title), theme, cluster, device);
	// },
	// VdPage_ClicouTab_Close: (title, theme, cluster, device) => {//ok
	// 	// return track('clique', 'sobre', normatize(title), 'conteudo', 'fechar', theme, cluster, device);
	// },
	// VdPage_ClicouPoster: (index, title, theme, cluster, device) => {//ok
	// 	// return track('clique', 'sobre', normatize(title), 'conteudo', null, theme, cluster, device);
	// },
	// VdPage_ClicouBullet: (index, title, session, theme, cluster, device) => {//ok
	// 	// return track('clique', 'sobre', normatize(title), 'conteudo', null, theme, cluster, device);
	// },
	// VdPage_MudouPoster: (title, subsectionName, theme, cluster, device) => {//ok
	// 	const complemento = device === 'm' ? ':scroll-lateral' : '';
	// 	const subsection = normatize(subsectionName);
	// 	const name = normatize(title);
	// 	return track('clique', 'sobre', subsection, 'conteudo', `${name}${complemento}`, theme, cluster, device);
	// },
	// VdPage_ArrowPrevPoster: (title, theme, cluster, device) => {//ok
	// 	return track('clique', 'sobre', 'sobre', 'conteudo', 'anterior', theme, cluster, device);
	// },
	// VdPage_ArrowNextPoster: (title, theme, cluster, device) => {//ok
	// 	return track('clique', 'sobre', 'sobre', 'conteudo', 'proxima', theme, cluster, device);
	// },
	// VdPage_ContentButton: (section, contentTitle, buttonLabel, theme, cluster, device) => {// N/A
	// 	return track('clique', 'sobre', normatize(contentTitle), 'conteudo', normatize(buttonLabel), theme, cluster, device);
	// },

	// GalleryPage ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	GalleryPage_ClicouPoster: (index, theme, cluster, device) => {//ok
		// return track('clique', 'galeria', 'galeria', 'conteudo', index, theme, cluster, device);
	},
	GalleryPage_ClicouThumb: (index, theme, cluster, device) => {//ok
		// return track('clique', 'galeria', 'galeria', 'conteudo', index, theme, cluster, device);
	},
	GalleryPage_ClicouBullet: (index, theme, cluster, device) => {//ok
		// return track('clique', 'galeria', 'galeria', 'conteudo', index, theme, cluster, device);
	},
	GalleryPage_MudouPoster: (index, theme, cluster, device) => {//ok
		return track('clique', 'galeria', 'galeria', 'conteudo', index, theme, cluster, device);
	},
	Galeria_C2A_LinkAgende: (title, theme, cluster, device) => {//ok
		return track('clique', 'galeria', 'cta', 'conteudo', 'compre-o-seu', theme, cluster, device);
	},

	// ActionPage ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	FooterPage_ClicouNavItem: (name, theme, cluster, device) => {//ok
		return track('clique', 'cta-mobile', 'cta', 'conteudo', normatize(name), theme, cluster, device);
	},
	FooterPage_ClicouSocialItem: (name, theme, cluster, device) => {//ok
		return track('clique', 'cta-mobile', 'cta', 'conteudo', normatize(name), theme, cluster, device);
	},
	FooterPage_ClicouAgendeSeuTesteDrive: (name, theme, cluster, device) => {//ok
		return track('clique', 'cta-mobile', 'cta', 'conteudo', normatize(name), theme, cluster, device);
	},

	// OffersPage ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	OffersCard_ClicouEuQuero: (id, mvsCode, theme, cluster, device) => {// N/A
		return null;
	},
	OffersCard_ClicouShare: (title, theme, cluster, device) => {// N/A
		return null;
	},
	OffersPage_ScrollOfertas: (title, theme, cluster, device) => {// N/A
		return null;
	},

	// Banner ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	Banner_ClicouLink: (theme, cluster, device) => {// N/A
		return null;
	},
};

export default data;

// ------------------------------------------------------------------------------------------------
// @see https://docs.google.com/spreadsheets/d/18kur6ERYv-13nom1Tp1oY2whrwVxZ9Nu/edit#gid=360237036
// ------------------------------------------------------------------------------------------------
